// Taxes Management Permissions

export const TAXES_INDEX = 211;
export const TAXES_CREATE = 212;
export const TAXES_UPDATE = 213;
export const TAXES_DELETE = 1494;
export const TAXES_RESTORE = 1396;
